// @flow
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
/* eslint-disable-next-line import/order */ // Prioritize loading polyfills.
import '@ungap/global-this'

import Bugsnag from '@bugsnag/js'
import { type GatsbyBrowser, navigate } from 'gatsby'
import * as React from 'react'

import { callback } from '@toggl/auth'
import { tracer } from '@toggl/bugsnag'
import intercom from '@toggl/intercom'

import { pricingPlanUrls } from './data/track/signup'
import { Provider } from './src/components/Provider'

declare var process: WebProcess
declare var document: Document
type $GatsbyBrowser<API: string> = $ElementType<GatsbyBrowser, API>

export const wrapRootElement: $GatsbyBrowser<'wrapRootElement'> = ({
  element,
}) => <Provider>{element}</Provider>

window.__tracer = Bugsnag.getPlugin(tracer.name).tracer

export const onClientEntry: $GatsbyBrowser<'onClientEntry'> = () => {
  callback.redirectLegacyAuthCallbacks()

  intercom.initialize({
    app_id: process.env.GATSBY_INTERCOM_APP_ID,
    vertical_padding: 20,
    horizontal_padding: 20,
  })
}

export const onInitialClientRender: $GatsbyBrowser<'onInitialClientRender'> = () => {
  callback.handleAuthErrors(navigate, pricingPlanUrls)
}
